import { TFilterColumns } from "../hooks/useOrderColumn";
import { DeclineOptions } from "../interfaces";

/**
 * SUPPORT
 * isEditable = status, printManufacturer, deliveryDate, internalNote, manufacturerNote
 * isToolTip = internalNote, manufacturerNote, lastOpened
 */

export const VIEW_ORDER_COLUMNS: TFilterColumns[] = [
  { accessor: "status", isEditable: true },
  { accessor: "printManufacturer", isEditable: true },
  { accessor: "deliveryDate", isEditable: true },
  { accessor: "createdAt" },
  { accessor: "uploadedDate" },
  { accessor: "shippingMethod", isEditable: true },
  { accessor: "productType" },
];

export const DECLINE_POSITION_IMAGE = [
  { key: DeclineOptions.ResolutionLow, value: "resolutionTooLow" },
  { key: DeclineOptions.WrongColor, value: "colorsAreWrong" },
  { key: DeclineOptions.Other, value: "other" },
];
